import { RenderIf, XResizableTextarea } from '../index';
import useCaseLiabilityTextFields from '../../hooks/useCaseLiabilityTextFields';
import { TOUR_TARGETS } from '../../constants/tourTargets';

// Renders liability text input fields
const CaseLiabilityTextFields = () => {
  const { shouldRender, isPremiseLiability, getFieldValue, getFieldName, handleChange } = useCaseLiabilityTextFields();

  return (
    <RenderIf shouldRender={shouldRender}>
      <div className="row mb-10!" data-tour={TOUR_TARGETS.LIABILITY_NARRATIVE}>
        <div className="col-md-12">
          <div className="form-group">
            <XResizableTextarea
              label="Describe how the incident occurred. The agent uses this information to build the liability paragraphs."
              name={getFieldName('howincidentOccured')}
              value={getFieldValue('howincidentOccured')}
              onChange={(e) => handleChange({ fieldName: 'howincidentOccured', value: e.target.value })}
              copyButton
            />
          </div>
        </div>

        <RenderIf shouldRender={isPremiseLiability}>
          <div className="col-md-12">
            <div className="form-group">
              <XResizableTextarea
                label="Describe The Dangerous Conditions"
                name={getFieldName('dangerousConditions')}
                value={getFieldValue('dangerousConditions')}
                onChange={(e) => handleChange({ fieldName: 'dangerousConditions', value: e.target.value })}
                copyButton
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <XResizableTextarea
                label="State Any Facts Regarding Notice"
                name={getFieldName('factsRegardingNotice')}
                value={getFieldValue('factsRegardingNotice')}
                onChange={(e) => handleChange({ fieldName: 'factsRegardingNotice', value: e.target.value })}
                copyButton
              />
            </div>
          </div>
        </RenderIf>
      </div>
    </RenderIf>
  );
};

export default CaseLiabilityTextFields;
